import React, { useEffect, useState } from 'react';
import { Chart } from 'primereact/chart';
import { Calendar } from 'primereact/calendar';
import car from '../../assets/images/car.png';
import user from '../../assets/images/users.png';
import dollar from '../../assets/images/dollar.png';
import time from '../../assets/images/time.png';
import { handleGetRequest } from '../../services/GetTemplate';
import users from '../../assets/images/users.png';

function DashboardSection({ title, cardsData, chartData, chartOptions, chartDataa, lightOptions, summaryData, distributionData }) {
    const formatDuration = (s) => {
        if (!s && s !== 0) return '0m';
        const secs = Number(s);
        if (isNaN(secs) || secs <= 0) return '0m';
        const hrs = Math.floor(secs / 3600);
        const mins = Math.floor((secs % 3600) / 60);
        return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
    };

    const cardsArray = Array.isArray(cardsData) ? cardsData : [];
    const revenueVal =
        summaryData?.totalRevenue ??
        (() => {
            const item = cardsArray.find((c) => c.title && c.title.toLowerCase().includes('revenue'));
            return item ? item.value : 0;
        })();

    return (
        <>
            {title && <h2 style={{ fontWeight: '600', color: '#000', marginBottom: '30px' }}>{title}</h2>}

            <div className="grid col-12 gap-3">
                {cardsArray.length
                    ? cardsArray.map((card, idx) => (
                          <div className="dashboard-cards p-3" key={idx}>
                              <div className="p-3 mb-4 round-sub-card">
                                  <img src={card.icon || users} alt="img" />
                                  {/* {card.value !== undefined && <p style={{ color: '#00A63E', fontWeight: '600' }}>{card.value}</p>} */}
                              </div>
                              <p className="card-heading">{card.title}</p>
                              <p className="card-sub-text">{card.title && card.title.toLowerCase().includes('revenue') ? `Rs ${card.value}` : card.value}</p>
                          </div>
                      ))
                    : null}
            </div>
            <div className="grid mt-2">
                <div className="col-12 md:col-6">
                    <div className="card">
                        {chartData && (
                            <div className="graphs__section">
                                <div className="Card__Round " style={{ border: 'none' }}>
                                    <h5 style={{ color: '#000' }}>User Activity Overview</h5>
                                    <p>Comparison of registered users and active users.</p>
                                    <Chart type="line" data={chartData} options={chartOptions} />
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="col-12 md:col-6">
                    <div className="card">
                        <h5 style={{ color: '#000' }}>Parking Analytics</h5>
                        <p>Overview of parking usage, activity, and performance metrics</p>
                        <div className="grid">
                            <div className="col-6">
                                <div className="card">
                                    <div className="flex justify-content-between align-items-center">
                                        <img style={{ width: '40px' }} src={users} alt="img" />
                                        <p style={{ fontWeight: '600' }}>Average Parking Time</p>
                                    </div>
                                    <div className="flex justify-content-between align-items-center mt-3">
                                        <p className="m-0" style={{ fontWeight: '600', fontSize: '16px' }}>
                                            {summaryData?.averageParkingTime || summaryData?.avgDuration ? `${Math.round((summaryData.averageParkingTime ?? summaryData.avgDuration) / 60)} hrs` : '0h'}
                                        </p>
                                        <p className="m-0" style={{ color: 'red', fontSize: '12px', fontWeight: '500' }}>
                                            {/* placeholder for delta */}-
                                        </p>
                                    </div>
                                    <Chart type="bar" data={chartData} options={chartOptions} />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="card">
                                    <div className="flex justify-content-between align-items-center">
                                        <img style={{ width: '40px' }} src={users} alt="img" />
                                        <p style={{ fontWeight: '600' }}>Top 3 Parking Duration</p>
                                    </div>
                                    {Array.isArray(summaryData?.topParkingSessions) &&
                                        summaryData.topParkingSessions.slice(0, 3).map((s, i) => (
                                            <div className="flex align-items-center mt-4" key={i}>
                                                <img src={users} style={{ height: '10px' }} />
                                                <h4 className="ml-4 mb-0 mt-0">{formatDuration(s.parkingDuration)}</h4>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mt-3">
                    <div className="grid nogutter">
                        <div className="col-8 pr-2">
                            <div className="flex align-item-center">
                                <h4>Total Revenue</h4>
                                {/* <p style={{ color: '#00A63E', marginLeft: '20px', fontSize: '18px' }}>Rs</p> */}
                            </div>
                            <p style={{ fontSize: '18px' }}>Overall earnings generated across all parking sites.</p>
                            <div className="flex align-item-center">
                                <p style={{ fontSize: '18px', marginTop: '8px' }}>Rs.</p>
                                <p style={{ fontSize: '26px', fontWeight: '500', marginLeft: '5px' }}>{summaryData?.totalRevenue ?? '0'}</p>
                            </div>
                            <div className="flex align-items-center mt-3">
                                <div style={{ width: '14px', height: '14px', background: '#2D8EFF', borderRadius: '3px' }} />
                                <p className="mt-3 ml-4">
                                    Cars - <span style={{ fontWeight: '600' }}>{summaryData?.carPercentage ?? '0'}%</span>
                                </p>
                                <div style={{ width: '14px', height: '14px', background: '#A7E0FF', borderRadius: '3px' }} className="ml-8" />
                                <p className="mt-3 ml-4">
                                    Motorcycles - <span style={{ fontWeight: '600' }}>{summaryData?.bikePercentage ?? '0'}%</span>
                                </p>
                                <div style={{ width: '14px', height: '14px', background: '#1E40AF', borderRadius: '3px' }} className="ml-8" />
                                <p className=" ml-4">
                                    Commercial Vehicles - <span style={{ fontWeight: '600' }}>{summaryData?.commercialVehicle ?? '0'}%</span>
                                </p>
                            </div>
                        </div>

                        <div className="col-4 pl-2">
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                {(() => {
                                    const donutData = {
                                        // labels: ['Cars', 'Motorcycles', 'Commercial Vehicles'],
                                        datasets: [
                                            {
                                                data: [summaryData?.carPercentage ?? 0, summaryData?.bikePercentage ?? 0, summaryData?.commercialVehicle ?? 0],
                                                backgroundColor: ['#2D8EFF', '#A7E0FF', '#1E40AF']
                                            }
                                        ]
                                    };

                                    const donutOptions = { maintainAspectRatio: false, plugins: { legend: { position: 'bottom' } } };

                                    return <Chart type="doughnut" data={donutData} options={donutOptions} style={{ width: '200px', height: '200px' }} />;
                                })()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

function CustomDashboard() {
    const [weeklyData, setWeeklyData] = useState([]);
    const [distributionData, setDistributionData] = useState(null);
    const [cardsData, setCardsData] = useState({});
    const [enforcementData, setEnforcementData] = useState({});
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const [chartDataa, setChartDataa] = useState({
        labels: ['Occupied', 'Available', 'Total Capacity'],
        datasets: [
            {
                data: [0, 0, 0],
                backgroundColor: ['#2D8EFF', '#8B5CF6', '#10B981']
            }
        ]
    });

    const lightOptions = {
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'bottom' }
        }
    };

    // Separate start and end date for main dashboard
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    // Independent dates for enforcement dashboard (so changing main dates doesn't affect enforcement)
    const [enfStartDate, setEnfStartDate] = useState(null);
    const [enfEndDate, setEnfEndDate] = useState(null);

    // Update charts — use static month labels (Jan–Dec)
    useEffect(() => {
        const staticMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        setChartData({
            labels: staticMonths,
            datasets: [
                {
                    label: 'Revenue',
                    data: weeklyData,
                    borderColor: '#2D8EFF',
                    tension: 0.4
                }
            ]
        });

        setChartOptions({ maintainAspectRatio: false });
    }, [weeklyData]);

    useEffect(() => {
        if (distributionData) {
            setChartDataa({
                labels: ['Occupied', 'Available', 'Total Capacity'],
                datasets: [
                    {
                        data: [distributionData.occupied || 0, distributionData.availableSlots || 0, distributionData.totalCapacity || 0],
                        backgroundColor: ['#2D8EFF', '#8B5CF6', '#10B981']
                    }
                ]
            });
        }
    }, [distributionData]);

    // Helper to format dates for API — return full ISO date-time as Swagger expects string($date-time)
    const formatDate = (date) => (date ? date.toISOString() : '');
    // Parse ISO date-time string from API into a Date object
    const parseDate = (iso) => {
        try {
            return iso ? new Date(iso) : null;
        } catch (e) {
            return null;
        }
    };

    // API calls with startDate and endDate
    const getWeeklyData = async () => {
        try {
            let url = 'portalDashboard/GetWeeklyRevenue';
            if (startDate && endDate) url += `?fromDate=${encodeURIComponent(formatDate(startDate))}&toDate=${encodeURIComponent(formatDate(endDate))}`;
            const res = await handleGetRequest(url, false);
            if (res?.success) {
                // support multiple shapes: res.data.revenue or res.revenue or res.data
                const revenueRaw = res.data?.revenue ?? res.revenue ?? res.data ?? res;
                const revenue = Array.isArray(revenueRaw) ? revenueRaw : revenueRaw?.revenue ?? [];
                setWeeklyData(revenue);
                const from = res.data?.fromDate ?? res.fromDate ?? (res.data && res.data.fromDate);
                const to = res.data?.toDate ?? res.toDate ?? (res.data && res.data.toDate);
                if (!startDate && from) setStartDate(parseDate(from));
                if (!endDate && to) setEndDate(parseDate(to));
            }
        } catch (err) {
            console.error('Failed to fetch weekly data:', err);
            setWeeklyData([]);
        }
    };

    const getRevenueData = async () => {
        try {
            let url = 'portalDashboard/GetTotalCapacityPieChart';
            if (startDate && endDate) url += `?fromDate=${encodeURIComponent(formatDate(startDate))}&toDate=${encodeURIComponent(formatDate(endDate))}`;
            const res = await handleGetRequest(url, false);
            if (res?.success) {
                const payload = res.data ?? res;
                setDistributionData(payload || { occupied: 0, availableSlots: 0, totalCapacity: 0 });
                const from = payload?.fromDate ?? res.fromDate;
                const to = payload?.toDate ?? res.toDate;
                if (!startDate && from) setStartDate(parseDate(from));
                if (!endDate && to) setEndDate(parseDate(to));
            }
        } catch (err) {
            console.error('Failed to fetch distribution data:', err);
            setDistributionData({ occupied: 0, availableSlots: 0, totalCapacity: 0 });
        }
    };

    const getCardsData = async () => {
        try {
            let url = 'portalDashboard/getSummary';
            if (startDate && endDate) url += `?fromDate=${encodeURIComponent(formatDate(startDate))}&toDate=${encodeURIComponent(formatDate(endDate))}`;
            const res = await handleGetRequest(url, false);
            if (res?.success) {
                const payload = res.data ?? res;
                setCardsData(payload || {});
                const from = payload?.fromDate ?? res.fromDate;
                const to = payload?.toDate ?? res.toDate;
                if (!startDate && from) setStartDate(parseDate(from));
                if (!endDate && to) setEndDate(parseDate(to));
            }
        } catch (err) {
            console.error('Failed to fetch main dashboard cards:', err);
            setCardsData({});
        }
    };

    const getEnforcementData = async () => {
        try {
            let url = 'portalDashboard/EnforcementDashboard';
            if (enfStartDate && enfEndDate) url += `?fromDate=${encodeURIComponent(formatDate(enfStartDate))}&toDate=${encodeURIComponent(formatDate(enfEndDate))}`;
            const res = await handleGetRequest(url, false);
            if (res?.success) {
                const payload = res.data ?? res;
                setEnforcementData(payload || {});
                const from = payload?.fromDate ?? res.fromDate;
                const to = payload?.toDate ?? res.toDate;
                if (!enfStartDate && from) setEnfStartDate(parseDate(from));
                if (!enfEndDate && to) setEnfEndDate(parseDate(to));
            }
        } catch (err) {
            console.error('Failed to fetch Enforcement dashboard cards:', err);
            setEnforcementData({});
        }
    };

    // const getEnforcementData = async () => {
    //    // try {
    //         // // let url = 'portalDashboard/GetEnforcementSummary';
    //         // if (startDate && endDate) url += `?startDate=${formatDate(startDate)}&endDate=${formatDate(endDate)}`;
    //     //     const res = await handleGetRequest(url, false);
    //     //     if (res?.success) setEnforcementData(res.data || {});
    //     //     else setEnforcementData({});
    //     // } catch (err) {
    //     //     console.error('Failed to fetch enforcement data:', err);
    //     //     setEnforcementData({});
    //     }
    // };

    // Initial load for main dashboard
    useEffect(() => {
        getWeeklyData();
        getRevenueData();
        getCardsData();
    }, [startDate, endDate]);

    // Initial and reactive load for enforcement dashboard (independent of main dashboard dates)
    useEffect(() => {
        getEnforcementData();
    }, [enfStartDate, enfEndDate]);

    const enforcementCards = [
        { title: 'Overstay', value: enforcementData?.overStay || 0, icon: time },
        { title: 'Non-Payment', value: enforcementData?.nonPayment || 0, icon: car },
        { title: 'Fine Amount', value: enforcementData?.amount || 0, icon: car },
        { title: 'Fine Count', value: enforcementData?.fineCount || 0, icon: time }
        // { title: 'Amount', value: enforcementData?.finesAmount || 0, icon: dollar }
    ];

    const mainDashboardCards = [
        // { title: 'Total Space', value: cardsData?.totalSpaces || 0, icon: car },
        { title: 'Active Officer Sessions', value: cardsData?.totalActiveUsers ?? cardsData?.activeUsers ?? 0, icon: user },
        // { title: 'Revenue Today', value: cardsData?.totalRevenue ?? cardsData?.revenueToday ?? 0, icon: dollar },
        { title: 'Scans', value: Math.round((cardsData?.averageParkingTime ?? cardsData?.avgDuration ?? 0) / 60) + ' hrs', icon: time },
        { title: 'Total Fines', value: cardsData?.totalFine ?? 0, icon: dollar },
        { title: 'Warnings', value: cardsData?.totalWarningCount ?? 0, icon: time }
    ];

    const today = React.useMemo(() => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }, []);

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                <h2 style={{ fontWeight: '600', color: '#000' }}>Main Dashboard</h2>

                {/* <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <Calendar
                        onChange={(e) => {
                            setStartDate(e.value);
                            if (endDate && e.value && endDate < e.value) {
                                setEndDate(null);
                            }
                        }}
                        maxDate={today}
                        value={startDate}
                        placeholder="Start Date"
                        dateFormat="yy-mm-dd"
                        style={{ width: '150px' }}
                    />
                    <Calendar maxDate={today} onChange={(e) => setEndDate(e.value)} minDate={startDate} value={endDate} placeholder="End Date" dateFormat="yy-mm-dd" style={{ width: '150px' }} />
                </div> */}
            </div>

            <DashboardSection cardsData={mainDashboardCards} chartData={chartData} chartOptions={chartOptions} chartDataa={chartDataa} lightOptions={lightOptions} summaryData={cardsData} distributionData={distributionData} />

            {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', marginTop: '150px' }}>
                <h2 style={{ fontWeight: '600', color: '#000' }}>Enforcement Dashboard</h2>

                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <Calendar
                        maxDate={today}
                        value={enfStartDate}
                        onChange={(e) => {
                            setEnfStartDate(e.value);
                            if (enfEndDate && e.value && enfEndDate < e.value) {
                                setEnfEndDate(null);
                            }
                        }}
                        placeholder="Start Date"
                        dateFormat="yy-mm-dd"
                        style={{ width: '150px' }}
                    />
                    <Calendar value={enfEndDate} onChange={(e) => setEnfEndDate(e.value)} maxDate={today} minDate={enfStartDate} placeholder="End Date" dateFormat="yy-mm-dd" style={{ width: '150px' }} />
                </div>
            </div> */}

            {/* <div>
                <DashboardSection cardsData={enforcementCards} chartData={chartData} chartOptions={chartOptions} chartDataa={chartDataa} lightOptions={lightOptions} />
            </div> */}
        </>
    );
}

export default CustomDashboard;
